export default __webpack_public_path__ + "locales/it/Article.json?hash=d9b8ba0f7c17b38b08d2784973efe061";